import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { Section } from '../components/Section';
import { LegalContent } from '../components/LegalContent';
import { Disclaimer } from '../components/Disclaimer';
import { company } from '../data/site';
import { termsSections } from '../data/legal';
export function TermsOfUse() {
  return <>
      <Seo title="Terms of Use | Futuramy Investment LLC" description="Terms of Use governing access to and use of the Futuramy Investment LLC website. Website content is provided for general informational purposes only." path="/terms-of-use" data-id="element-286" data-mp="36lh6qj2b0if1" />
      <PageHeader eyebrow="Legal" title="Terms of Use" subtitle="Terms governing your access to and use of this website." data-id="element-287" data-mp="2ivwk9q6xz310" />
      <Section data-id="element-288" data-mp="29svghw5jto0i">
        <LegalContent sections={termsSections} lastUpdated={company.lastUpdated} data-id="element-289" data-mp="29uganknyb4xu" />
      </Section>
      <Disclaimer data-id="element-290" data-mp="2dtxek9nqbu0w" />
    </>;
}